import { createSlice, isAnyOf } from '@reduxjs/toolkit'
import {
  getVendorErrorRowsAsync,
  getSkuErrorRowsAsync,
  getPoErrorRowsAsync,
  getVendorEnrichedDataAsync,
  getSkuEnrichedDataAsync,
  getAllVendorDataAsync,
  getEditSkuDataAsync,
  getEditPoDataAsync,
  getEnrichContextAsync,
} from 'src/services/dataManagement/dataManagement.services'

const initialState = {
  vendor: {
    vendorDataLoading: false,
    vendorData: [],
  },
  sku: {
    skuDataLoading: false,
    skuData: [],
  },
  po: {
    poDataLoading: false,
    poData: [],
  },
  enrichmentContextLoader: false,
  enrichmentContext: {
    vendorType: null,
    productType: null,
    htsCode: null,
  },
  showEnrichmentRowsToggle: {
    vendorToggle: false,
    skuToggle: false,
  },
  checkStatus: {
    vendorType: false,
    productType: false,
    htsCode: false,
  },

  landingPageCurrentTab: 1,
  totalVendorCount: 0,
  totalSkuCount: 0,
  totalPoCount: 0,
  totalEnrichedVendorCount: 0,
  totalEnrichedSkuCount: 0,
}

export const getDataManagementDetailsSlice = createSlice({
  name: 'data-management-slice',
  initialState,
  extraReducers: (builder) => {
    // Error drawer
    builder.addMatcher(isAnyOf(getVendorErrorRowsAsync.pending), (state) => {
      state.vendor.vendorDataLoading = true
    })
    builder.addMatcher(isAnyOf(getVendorErrorRowsAsync.fulfilled), (state, action) => {
      state.vendor.vendorDataLoading = false
      // state.vendor.vendorData = action.payload.data
    })
    builder.addMatcher(isAnyOf(getVendorErrorRowsAsync.rejected), (state, action) => {
      state.vendor.vendorDataLoading = false
    })
    builder.addMatcher(isAnyOf(getSkuErrorRowsAsync.pending), (state) => {
      state.sku.skuDataLoading = true
    })
    builder.addMatcher(isAnyOf(getSkuErrorRowsAsync.fulfilled), (state, action) => {
      state.sku.skuDataLoading = false
      // state.sku.skuData = action.payload.data
    })
    builder.addMatcher(isAnyOf(getSkuErrorRowsAsync.rejected), (state, action) => {
      state.sku.skuDataLoading = false
    })
    builder.addMatcher(isAnyOf(getPoErrorRowsAsync.pending), (state) => {
      state.po.poDataLoading = true
    })
    builder.addMatcher(isAnyOf(getPoErrorRowsAsync.fulfilled), (state, action) => {
      state.po.poDataLoading = false
      // state.po.poData = action.payload.data
    })
    builder.addMatcher(isAnyOf(getPoErrorRowsAsync.rejected), (state, action) => {
      state.po.poDataLoading = false
    })
    builder.addMatcher(isAnyOf(getVendorEnrichedDataAsync.pending), (state) => {
      state.vendor.vendorDataLoading = true
      // state.sku.skuDataLoading = true
    })
    builder.addMatcher(isAnyOf(getVendorEnrichedDataAsync.fulfilled), (state, action) => {
      // state.vendor.vendorData = action.payload.data.enriched_vendor
      state.vendor.vendorDataLoading = false
    })
    builder.addMatcher(isAnyOf(getVendorEnrichedDataAsync.rejected), (state, action) => {
      state.vendor.vendorDataLoading = false
    })
    builder.addMatcher(isAnyOf(getSkuEnrichedDataAsync.pending), (state) => {
      state.sku.skuDataLoading = true
    })
    builder.addMatcher(isAnyOf(getSkuEnrichedDataAsync.fulfilled), (state, action) => {
      // state.sku.skuData = action.payload.data.enriched_sku
      state.sku.skuDataLoading = false
    })
    builder.addMatcher(isAnyOf(getSkuEnrichedDataAsync.rejected), (state, action) => {
      state.sku.skuDataLoading = false
    })

    // Edit drawer
    builder.addMatcher(isAnyOf(getAllVendorDataAsync.pending), (state) => {
      state.vendor.vendorDataLoading = true
    })
    builder.addMatcher(isAnyOf(getAllVendorDataAsync.fulfilled), (state, action) => {
      state.vendor.vendorDataLoading = false
      // state.vendor.vendorData = action.payload.data
    })
    builder.addMatcher(isAnyOf(getAllVendorDataAsync.rejected), (state, action) => {
      state.vendor.vendorDataLoading = false
    })
    builder.addMatcher(isAnyOf(getEditSkuDataAsync.pending), (state) => {
      state.sku.skuDataLoading = true
    })
    builder.addMatcher(isAnyOf(getEditSkuDataAsync.fulfilled), (state, action) => {
      state.sku.skuDataLoading = false
      // state.sku.skuData = action.payload.data
    })
    builder.addMatcher(isAnyOf(getEditSkuDataAsync.rejected), (state, action) => {
      state.sku.skuDataLoading = false
    })
    builder.addMatcher(isAnyOf(getEditPoDataAsync.pending), (state) => {
      state.po.poDataLoading = true
    })
    builder.addMatcher(isAnyOf(getEditPoDataAsync.fulfilled), (state, action) => {
      state.po.poDataLoading = false
      // state.po.poData = action.payload.data
    })
    builder.addMatcher(isAnyOf(getEditPoDataAsync.rejected), (state, action) => {
      state.po.poDataLoading = false
    })
    builder.addMatcher(isAnyOf(getEnrichContextAsync.pending), (state) => {
      state.po.enrichmentContextLoader = true
    })
    builder.addMatcher(isAnyOf(getEnrichContextAsync.fulfilled), (state, action) => {
      state.po.enrichmentContextLoader = false
      state.enrichmentContext = {
        htsCode: action.payload.data.hts_code_context || null,
        productType: action.payload.data.product_type_context || null,
        vendorType: action.payload.data.vendor_type_context || null,
      }
    })
    builder.addMatcher(isAnyOf(getEnrichContextAsync.rejected), (state, action) => {
      state.po.enrichmentContextLoader = false
    })
  },
  reducers: {
    setVendorData: (state, action) => {
      state.vendor.vendorData = action.payload
    },
    resetVendorData: (state) => {
      state.vendor = initialState.vendor
    },
    setSkuData: (state, action) => {
      state.sku.skuData = action.payload
    },
    resetSkuData: (state) => {
      state.sku = initialState.sku
    },
    setPoData: (state, action) => {
      state.po.poData = action.payload
    },
    resetPoData: (state) => {
      state.po = initialState.po
    },
    setAddNewRow: (state, action) => {
      const { tab, arrKey, newRow } = action.payload
      state[tab][arrKey].unshift(newRow)
    },
    resetEnrichmentContext: (state) => {
      state.enrichmentContext = initialState.enrichmentContext
    },
    setShowEnrichmentRowsToggle: (state, action) => {
      state.showEnrichmentRowsToggle = action.payload
    },
    resetShowEnrichmentRowsToggle: (state) => {
      state.showEnrichmentRowsToggle = initialState.showEnrichmentRowsToggle
    },
    setLandingPageCurrentTab: (state, action) => {
      state.landingPageCurrentTab = action.payload
    },
    resetLandingPageCurrentTab: (state) => {
      state.landingPageCurrentTab = initialState.landingPageCurrentTab
    },
    setTotalVendorCount: (state, action) => {
      state.totalVendorCount = action.payload
    },
    resetTotalVendorCount: (state) => {
      state.totalVendorCount = initialState.totalVendorCount
    },
    setTotalSkuCount: (state, action) => {
      state.totalSkuCount = action.payload
    },
    resetTotalSkuCount: (state) => {
      state.totalSkuCount = initialState.totalSkuCount
    },
    setTotalPoCount: (state, action) => {
      state.totalPoCount = action.payload
    },
    resetTotalPoCount: (state) => {
      state.totalPoCount = initialState.totalPoCount
    },
    setCheckStatus: (state, action) => {
      state.checkStatus = action.payload
    },
    resetCheckStatus: (state) => {
      state.checkStatus = initialState.checkStatus
    },
  },
})

export const {
  setVendorData,
  resetVendorData,
  setSkuData,
  resetSkuData,
  setPoData,
  resetPoData,
  setAddNewRow,
  resetEnrichmentContext,
  setShowEnrichmentRowsToggle,
  resetShowEnrichmentRowsToggle,
  setLandingPageCurrentTab,
  resetLandingPageCurrentTab,
  setTotalVendorCount,
  resetTotalVendorCount,
  setTotalSkuCount,
  resetTotalSkuCount,
  setTotalPoCount,
  resetTotalPoCount,
  setCheckStatus,
  resetCheckStatus,
} = getDataManagementDetailsSlice.actions

export default getDataManagementDetailsSlice.reducer
